export default __webpack_public_path__ + "static/health_icon-6683da4e66734703da9dfd1dce813176.png";